function buildStatusMeta(clip) {
  if (clip.isSharedWithMe) {
    return {
      badge: "Shared with you",
      badgeClass: "confession-saved-status-sent",
      delivery: "Shared directly with you",
      privacy: "Available for you to review now",
    };
  }
  if (clip.sentAt || clip.deliveredAt || clip.deliveryStatus === "sent") {
    return {
      badge: "Sent",
      badgeClass: "confession-saved-status-sent",
      delivery: "Delivered to your chosen recipient",
      privacy: "Delivered through your chosen sharing flow",
    };
  }
  if (clip.recipientAccessAfterRelease) {
    return {
      badge: "Scheduled",
      badgeClass: "confession-saved-status-scheduled",
      delivery: "After your release checks",
      privacy: "Private until your release settings allow access",
    };
  }
  return {
    badge: "Private",
    badgeClass: "confession-saved-status-private",
    delivery: "Deliver now",
    privacy: "Private unless you choose to deliver it",
  };
}

export function ConfessionCard({
  clip,
  durationLabel,
  recipientLabel,
  onReview,
  titleOverride,
  subtitleOverride,
  statusTextOverride,
  onRetryNotification,
  retryingNotification = false,
}) {
  const statusMeta = buildStatusMeta(clip);

  return (
    <article className="confession-saved-card-shell">
      <button
        type="button"
        className="confession-saved-card-button"
        onClick={() => onReview(clip)}
        aria-label={`Review private message ${clip.title}`}
      >
        <div className="confession-saved-card-preview">
          <div className="confession-saved-fallback">
            <span className="confession-thumbnail-icon" aria-hidden>
              ▶
            </span>
            <span className="confession-thumbnail-label">Private message</span>
            {durationLabel ? (
              <span className="confession-thumbnail-duration">{durationLabel}</span>
            ) : null}
          </div>
          <div className="confession-review-overlay" aria-hidden>
            <span>Play</span>
            <span>Edit</span>
            <span>Deliver</span>
          </div>
        </div>

        <div className="confession-saved-card-body">
          <div className="confession-saved-card-header">
            <strong>{clip.title}</strong>
            <span className={`confession-saved-status ${statusMeta.badgeClass}`}>
              {titleOverride || statusMeta.badge}
            </span>
          </div>
          <span className="confession-saved-recipient">{subtitleOverride || recipientLabel}</span>
          <span className="confession-saved-delivery">{statusTextOverride || statusMeta.delivery}</span>
          {clip.contextNote ? (
            <p className="confession-saved-note">{clip.contextNote}</p>
          ) : (
            <p className="confession-saved-note confession-saved-note-muted">
              No context note added
            </p>
          )}
          <div className="confession-saved-meta">
            {durationLabel ? (
              <span className="confession-saved-meta-chip">{durationLabel}</span>
            ) : null}
            <span className="confession-saved-meta-chip">{clip.displayDateLabel}</span>
            <span className="confession-saved-meta-chip">{clip.sizeLabel}</span>
          </div>
          <span className="confession-saved-privacy">{statusMeta.privacy}</span>
        </div>
      </button>
      {clip.emailNotificationStatus === "SENT" ? (
        <span className="confession-saved-privacy confession-saved-privacy-positive">
          Recipient notified
        </span>
      ) : null}
      {clip.emailNotificationStatus === "FAILED" ? (
        <div className="confession-saved-notification-warning">
          <span>Saved, but notification could not be sent. You can retry.</span>
          {onRetryNotification ? (
            <button
              type="button"
              className="secondary"
              onClick={() => onRetryNotification(clip)}
              disabled={retryingNotification}
            >
              {retryingNotification ? "Retrying..." : "Retry notification"}
            </button>
          ) : null}
        </div>
      ) : null}
    </article>
  );
}
